import colors, {IColors} from '../colors'

interface IAppTheme {
    fontFamily: string
    primary: string,
    primary1: string,
    primary2: string,
    primary3: string,

    secondary: string,

    tertiary: string,

    sm: number,
    md: number,
    lg: number,
    xl: number,

    smInner: number,
    mdInner: number,
    lgInner: number,
    xlInner: number
}

interface ITheme extends IAppTheme, IColors {}

const appTheme: IAppTheme = {
    fontFamily: 'Lato, sans-serif',

    primary: colors.estadao,
    primary1: colors.estadao,
    primary2: colors.estadaoLight,
    primary3: colors.estadaoDark,

    secondary: colors.grey,

    tertiary: colors.black,

    sm: 576,
    md: 768,
    lg: 1024,
    xl: 1322,

    smInner: 546,
    mdInner: 738,
    lgInner: 994,
    xlInner: 1292
}

const theme: ITheme = { ...colors, ...appTheme }

export default theme
